import { createStyles, makeStyles } from '@material-ui/core';
import { VerticalSplit } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import { useLocalization, useViewerState } from "../../hooks/index.js";
import { ToggleBase } from "./toggle-base.js";
const useStyles = makeStyles(theme => {
  return createStyles({
    iconButton: {},
    icon: {},
    iconActive: {
      fill: theme.palette.primary.main
    }
  });
});
/**
 * Document widget component that toggles the thumbnails
 */
export const ToggleThumbnailsWidget = props => {
  const classes = useStyles(props);
  const localization = useLocalization();
  const viewerState = useViewerState();
  return /*#__PURE__*/React.createElement(ToggleBase, {
    classes: classes,
    title: localization.toggleThumbnails,
    active: viewerState.showThumbnails,
    setValue: v => viewerState.updateState({
      showThumbnails: v
    })
  }, /*#__PURE__*/React.createElement(VerticalSplit, {
    className: clsx(classes.icon, {
      [classes.iconActive]: viewerState.showThumbnails
    })
  }));
};
//# sourceMappingURL=toggle-thumbnails.js.map